module.exports = __webpack_public_path__ + "img/arrows-to-line.9e313ef6.svg";